import { AdvanceRuleEngineState, AdvanceRuleEngineAction } from './advanceRuleEngineType';
import { advanceRuleEngineTypes } from '../reduxExports';


const advanceRuleEngineInitialState: AdvanceRuleEngineState = {
    advanceRuleEngineFormRedux: null,
    advanceRuleEngineRuleList: null,
    advanceRuleEngineListCount: 0,
    advanceRuleEngineListTableProps: {
        view: 'list',
        sortBy: 'createdAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    advanceRuleEngineListLoader: false,
    advanceRuleEngineSearchHash: null,
    advanceRuleEngineFilterHash: null,
    advanceRuleEngineRuleHistoryList: null,
    advanceRuleEngineHistoryListCount: 0,
    advanceRuleEngineHistoryListTableProps: {
        view: 'list',
        sortBy: 'fireTime',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    advanceRuleEngineHistoryListSearchHash: null,
    advanceRuleEngineHistoryListFilterHash: null,
    derivedConditionFormRedux: null,
    derivedConditionsList: null,
    derivedConditionsListCount: 0,
    derivedConditionsSearchHash: null,
    derivedConditionsFilterHash: null,
    derivedConditionsListTableProps: {
        view: 'list',
        sortBy: 'createdAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    ruleExecutionSummary: null,
    ruleExecutionSummaryCount: 0,
    ruleExecutionSummaryLoader: false,
    ruleExecutionSummaryListTableProps: {
        view: 'list',
        sortBy: 'fireTime',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    ruleExecutionSummaryFilterHash: null,
    advanceRuleEngineLayoutView: 'list',
    ruleTriggerLogs: null,
    ruleTriggerLogsCount: 0,
    ruleTriggerLogsLoader: false,
    ruleTriggerLogsListTableProps: {
        view: 'list',
        sortBy: 'logTime',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    ruleTriggerLogsFilterHash: null,
}




const advanceRuleEngineReducer = (
    state: AdvanceRuleEngineState = advanceRuleEngineInitialState,
    action: AdvanceRuleEngineAction
): AdvanceRuleEngineState => {
    switch(action.type) {
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_FORM_REDUX:
            return {
                ...state,
                advanceRuleEngineFormRedux: action.advanceRuleEngineFormRedux
            }
        case advanceRuleEngineTypes.CLEAR_ADVANCE_RULE_ENGINE_FORM_REDUX:
            return {
                ...state,
                advanceRuleEngineFormRedux: action.advanceRuleEngineFormRedux ?? null
            }
        case advanceRuleEngineTypes.FETCH_ADVANCE_RULE_ENGINE_RULE_LIST:
            return {
                ...state,
                advanceRuleEngineRuleList: action.advanceRuleEngineRuleList,
                advanceRuleEngineListCount: action.advanceRuleEngineListCount
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_REQUEST_HASH:
            return {
                ...state,
                advanceRuleEngineSearchHash: action.advanceRuleEngineSearchHash,
                advanceRuleEngineFilterHash: action.advanceRuleEngineFilterHash
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER:
            return {
                ...state,
                advanceRuleEngineListLoader: action.advanceRuleEngineListLoader
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_TABLE_PROPS:
            return {
                ...state,
                advanceRuleEngineListTableProps: action.advanceRuleEngineListTableProps
            }
        case advanceRuleEngineTypes.FETCH_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY:
            return {
                ...state,
                advanceRuleEngineRuleHistoryList: action.advanceRuleEngineRuleHistoryList,
                advanceRuleEngineHistoryListCount: action.advanceRuleEngineHistoryListCount
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_REQUEST_HASH:
            return {
                ...state,
                advanceRuleEngineHistoryListSearchHash: action.advanceRuleEngineHistoryListSearchHash,
                advanceRuleEngineHistoryListFilterHash: action.advanceRuleEngineHistoryListFilterHash
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_TABLE_PROPS:
            return {
                ...state,
                advanceRuleEngineHistoryListTableProps: action.advanceRuleEngineHistoryListTableProps
            }
        case advanceRuleEngineTypes.SET_DERIVED_CONDITION_FORM_REDUX:
            return {
                ...state,
                derivedConditionFormRedux: action.derivedConditionFormRedux
            }
        case advanceRuleEngineTypes.CLEAR_DERIVED_CONDITION_FORM_REDUX:
            return {
                ...state,
                derivedConditionFormRedux: action.derivedConditionFormRedux ?? null
            }

        case advanceRuleEngineTypes.CLEAR_ADVANCE_RULE_ENGINE_DASHBOARD:
            return {
                ...state,
                advanceRuleEngineListTableProps: {
                    view: 'list',
                    sortBy: 'createdAt',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: null
                },
                advanceRuleEngineHistoryListTableProps: {
                    view: 'list',
                    sortBy: 'fireTime',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: null
                },
                derivedConditionsListTableProps: {
                    view: 'list',
                    sortBy: 'createdAt',
                    order: 'descending',
                    pageSize: 15,
                    pageNumber: 1,
                    searchTerm: null
                }

            }

        case advanceRuleEngineTypes.FETCH_DERIVED_CONDITIONS_LIST:
            return {
                ...state,
                derivedConditionsList: action.derivedConditionsList,
                derivedConditionsListCount: action.derivedConditionsListCount
            }
        case advanceRuleEngineTypes.SET_DERIVED_CONDITIONS_LIST_REQUEST_HASH:
            return {
                ...state,
                derivedConditionsSearchHash: action.derivedConditionsSearchHash,
                derivedConditionsFilterHash: action.derivedConditionsFilterHash
            }
        case advanceRuleEngineTypes.SET_DERIVED_CONDITIONS_LIST_TABLE_PROPS:
            return {
                ...state,
                derivedConditionsListTableProps: action.derivedConditionsListTableProps
            }
        case advanceRuleEngineTypes.FETCH_RULE_EXECUTION_SUMMARY_LIST:
            return {
                ...state,
                ruleExecutionSummary: action.ruleExecutionSummary,
                ruleExecutionSummaryCount: action.ruleExecutionSummaryCount
            }
        case advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LIST_TABLE_PROPS:
            return {
                ...state,
                ruleExecutionSummaryListTableProps: action.ruleExecutionSummaryListTableProps
            }
        case advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LIST_REQUEST_HASH:
            return {
                ...state,
                ruleExecutionSummaryFilterHash: action.ruleExecutionSummaryFilterHash
            }
        case advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LOADER:
            return {
                ...state,
                ruleExecutionSummaryLoader: action.ruleExecutionSummaryLoader ?? false
            }
        case advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_LAYOUT_VIEW:
            return {
                ...state,
                advanceRuleEngineLayoutView: action.advanceRuleEngineLayoutView ?? 'list'
            }
        case advanceRuleEngineTypes.FETCH_RULE_TRIGGER_LOGS_LIST:
            return {
                ...state,
                ruleTriggerLogs: action.ruleTriggerLogs,
                ruleTriggerLogsCount: action.ruleTriggerLogsCount
            }
        case advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LIST_TABLE_PROPS:
            return {
                ...state,
                ruleTriggerLogsListTableProps: action.ruleTriggerLogsListTableProps
            }
        case advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LIST_REQUEST_HASH:
            return {
                ...state,
                ruleTriggerLogsFilterHash: action.ruleTriggerLogsFilterHash
            }
        case advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LOADER:
            return {
                ...state,
                ruleTriggerLogsLoader: action.ruleTriggerLogsLoader ?? false
            }
        default:
            return state;
    }
}

export default advanceRuleEngineReducer;